export default {
  SET_IS_FOLD_MENU(state, params) {
    state.isFoldMenu = params;
  },
  SET_HELP_OBJ_LIST(state, params) {
    state.helpObjList = params;
  },
  SET_HELP_OBJ(state, params) {
    state.helpObj = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/common/common/commonMutations.js